import { UseFormReturn } from 'react-hook-form';
import { useEditableTableLogic } from '../hooks';
import { createContext } from 'react';
import { useContext } from 'react';

import { FieldValues } from 'react-hook-form';
import { CustomUIEditingControls, EditingControls } from '../types';

export interface EditingContextValue<T extends FieldValues> {
	formMethods: UseFormReturn<T>;
	editTableLogic: ReturnType<typeof useEditableTableLogic>;
	editingControls: EditingControls<T>;
	costumUIEditingControls?: CustomUIEditingControls;
}

export function createEditingTableContext<T extends FieldValues>() {
	return createContext<EditingContextValue<T> | null>(null);
}

export function createUseEditingContext<T extends FieldValues>(
	EditingContext: React.Context<EditingContextValue<T> | null>,
) {
	return function useTypedEditingContext() {
		const ctx = useContext(EditingContext) as EditingContextValue<T>;
		if (!ctx) throw new Error('Missing EditingContext');
		return ctx;
	};
}
